enum AuthenticationType {
    CheckedToken = "authentication/CHECKED_TOKEN",
    SignIn = "authentication/SIGN_IN",
    SignOut = "authentication/SIGN_OUT",
}

export default AuthenticationType;
